/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function () {
  var ARCHIVED_TAG = 'archived';
  var ARCHIVED_LABEL_TAG = 'pfs:label-archive';
  var ARCHIVES_PATH = /\/collections\/the-archives\/?(?:$|\?)/i;
  var isUpdating = false;
  var scheduled = false;

  function isArchivesCollection() {
    return ARCHIVES_PATH.test(window.location.pathname || '');
  }

  function markArchivesBody() {
    if (!document.body) return;
    if (isArchivesCollection()) {
      document.body.classList.add('gm-collection-the-archives');
    } else {
      document.body.classList.remove('gm-collection-the-archives');
    }
  }

  function normalizeTag(tag) {
    return String(tag || '')
      .trim()
      .toLowerCase();
  }

  function tagsIncludeArchived(tags) {
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      var tag = normalizeTag(tags[i]);
      if (tag === ARCHIVED_TAG || tag === ARCHIVED_LABEL_TAG || tag.indexOf('pfs:label-archive') === 0) {
        return true;
      }
    }
    return false;
  }

  function getProductTags(productEl) {
    var id = productEl.getAttribute('data-product-id') || productEl.id;
    if (id && window.igProductData) {
      var ig = window.igProductData[id] || window.igProductData[String(id)];
      if (ig && ig.tags && ig.tags.length) return ig.tags;
    }

    var raw = productEl.getAttribute('data-product');
    if (raw) {
      try {
        var data = JSON.parse(raw);
        if (data && data.tags && data.tags.length) return data.tags;
      } catch (e) {}
    }

    return [];
  }

  function isArchivedProduct(productEl) {
    if (tagsIncludeArchived(getProductTags(productEl))) return true;

    var labels = productEl.querySelectorAll(
      '.boost-sd__product-label--custom-label-by-tag, .boost-sd__product-label--customLabelByTag, .boost-sd__product-label--gm-archived'
    );
    for (var i = 0; i < labels.length; i++) {
      if (/archive/i.test(labels[i].textContent || '')) return true;
    }

    return false;
  }

  function findArchivedLabel(productEl) {
    var labeled = productEl.querySelectorAll('.boost-sd__product-label');
    for (var i = 0; i < labeled.length; i++) {
      if (labeled[i].classList.contains('boost-sd__product-label--gm-archived')) {
        return labeled[i];
      }
      if (/^archived$/i.test((labeled[i].textContent || '').replace(/\s+/g, ' ').trim())) {
        return labeled[i];
      }
    }

    return (
      productEl.querySelector('.boost-sd__product-label--custom-label-by-tag') ||
      productEl.querySelector('.boost-sd__product-label--customLabelByTag')
    );
  }

  function setLabelText(label, text) {
    var textNode =
      label.querySelector('.boost-sd__product-label-text span') ||
      label.querySelector('.boost-sd__product-label-text') ||
      label;
    if (normalizeTag(textNode.textContent) !== normalizeTag(text)) {
      textNode.textContent = text;
    }
  }

  function ensureArchivedLabel(productEl) {
    var existing = findArchivedLabel(productEl);
    if (existing) {
      existing.classList.add('boost-sd__product-label--gm-archived');
      setLabelText(existing, 'ARCHIVED');
      return;
    }

    // Already processed once but Boost hasn't painted a label yet — wait for next render
    if (productEl.getAttribute('data-gm-archived-label') === 'pending') return;

    var soldOut = productEl.querySelector('.boost-sd__product-label--soldout');
    if (!soldOut || !soldOut.parentNode) {
      productEl.setAttribute('data-gm-archived-label', 'pending');
      return;
    }

    var label = document.createElement('div');
    label.className =
      'boost-sd__product-label boost-sd__product-label--text boost-sd__product-label--rectangle boost-sd__product-label--custom-label-by-tag boost-sd__product-label--gm-archived';
    label.innerHTML =
      '<span class="boost-sd__product-label-text"><span>ARCHIVED</span></span>';
    soldOut.parentNode.insertBefore(label, soldOut);
    productEl.setAttribute('data-gm-archived-label', 'ready');
  }

  function hideSoldOutLabels(productEl) {
    var soldOutLabels = productEl.querySelectorAll('.boost-sd__product-label--soldout');
    for (var j = 0; j < soldOutLabels.length; j++) {
      if (!soldOutLabels[j].hasAttribute('data-gm-hidden-soldout')) {
        soldOutLabels[j].setAttribute('data-gm-hidden-soldout', 'true');
        soldOutLabels[j].setAttribute('hidden', 'hidden');
        soldOutLabels[j].style.setProperty('display', 'none', 'important');
      }
    }
  }

  function dedupeArchivedLabels(productEl) {
    var labels = productEl.querySelectorAll('.boost-sd__product-label--gm-archived');
    for (var i = 1; i < labels.length; i++) {
      if (labels[i].parentNode) labels[i].parentNode.removeChild(labels[i]);
    }
  }

  function processArchivedProductLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = scope.querySelectorAll
      ? scope.querySelectorAll('.boost-sd__product-item')
      : [];

    if (root && root.classList && root.classList.contains('boost-sd__product-item')) {
      items = [root];
    }

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!isArchivedProduct(item)) continue;

      item.classList.add('gm-product--archived');
      ensureArchivedLabel(item);
      dedupeArchivedLabels(item);
      hideSoldOutLabels(item);
    }
  }

  function hideArchivesColorFilter(root) {
    if (!isArchivesCollection()) return;

    var scope = root && root.querySelectorAll ? root : document;
    var options = scope.querySelectorAll ? scope.querySelectorAll('.boost-sd__filter-option') : [];

    if (root && root.classList && /boost-sd__filter-option/.test(root.className || '')) {
      options = [root];
    }

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      if (option.classList.contains('gm-filter-option--hidden-color')) continue;

      var titleEl = option.querySelector(
        '.boost-sd__filter-option-title, .boost-sd__filter-option-label, h3, [class*="filter-option-title"]'
      );
      var title = ((titleEl && titleEl.textContent) || '').replace(/\s+/g, ' ').trim();
      var optionText = (option.textContent || '').replace(/\s+/g, ' ').trim();
      var identity = [
        option.id,
        option.getAttribute('data-id'),
        option.getAttribute('data-filter-id'),
        option.getAttribute('data-option-id'),
        option.getAttribute('data-filter-option-id'),
        option.className,
      ]
        .join(' ')
        .toLowerCase();

      var isColor =
        /^color\b/i.test(title) ||
        /^color\b/i.test(optionText) ||
        identity.indexOf('pf_opt_color') !== -1 ||
        identity.indexOf('filter-option-color') !== -1 ||
        identity.indexOf('option-color') !== -1 ||
        (!!option.querySelector('.boost-sd__filter-option-swatch-item') &&
          /#([0-9a-f]{3}|[0-9a-f]{6})\b/i.test(optionText));

      if (!isColor) continue;

      option.classList.add('gm-filter-option--hidden-color');
      option.setAttribute('hidden', 'hidden');
      option.style.setProperty('display', 'none', 'important');
    }
  }

  function refreshBoostCustomizations(root) {
    if (isUpdating) return;
    isUpdating = true;
    try {
      markArchivesBody();
      processArchivedProductLabels(root || document);
      hideArchivesColorFilter(root || document);
    } finally {
      requestAnimationFrame(function () {
        isUpdating = false;
      });
    }
  }

  function scheduleRefresh() {
    if (isUpdating || scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refreshBoostCustomizations(document);
    });
  }

  // Mobile Instant Search: keep search bar visible on open
  function resetInstantSearchViewport() {
    if (document.body) {
      document.body.classList.remove('nav-expanded');
    }

    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    var wrapper = document.querySelector('.boost-sd__search-bar-wrapper');
    if (wrapper) wrapper.scrollTop = 0;

    var bar = document.querySelector('.boost-sd__search-bar');
    if (bar && typeof bar.scrollIntoView === 'function') {
      bar.scrollIntoView({ block: 'start', inline: 'nearest' });
    }
  }

  function bindInstantSearchFix() {
    if (!document.body) return;

    var scrollY = 0;
    var wasOpen = document.body.classList.contains('boost-sd__search-opening');

    var observer = new MutationObserver(function () {
      var isOpen = document.body.classList.contains('boost-sd__search-opening');

      if (isOpen && !wasOpen) {
        scrollY = window.scrollY || window.pageYOffset || 0;
        resetInstantSearchViewport();
        setTimeout(resetInstantSearchViewport, 50);
        setTimeout(resetInstantSearchViewport, 300);
      } else if (!isOpen && wasOpen) {
        window.scrollTo(0, scrollY);
      }

      wasOpen = isOpen;
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function bindArchivesCustomizations() {
    if (!document.body) return;

    refreshBoostCustomizations(document);

    var observer = new MutationObserver(function (mutations) {
      if (isUpdating) return;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList') continue;

        var nodes = [];
        if (mutation.addedNodes && mutation.addedNodes.length) {
          for (var n = 0; n < mutation.addedNodes.length; n++) nodes.push(mutation.addedNodes[n]);
        }
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.classList &&
              (node.classList.contains('boost-sd__product-item') ||
                node.classList.contains('boost-sd__filter-option') ||
                node.classList.contains('boost-sd__product-list') ||
                node.classList.contains('boost-sd__filter-tree-wrapper'))) ||
            (node.querySelector &&
              node.querySelector(
                '.boost-sd__product-item, .boost-sd__filter-option, .boost-sd__product-list'
              ))
          ) {
            scheduleRefresh();
            return;
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(function () {
      refreshBoostCustomizations(document);
    }, 1000);
    setTimeout(function () {
      refreshBoostCustomizations(document);
    }, 3000);
  }

  function init() {
    bindInstantSearchFix();
    bindArchivesCustomizations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
